import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ClearingService, isStoreEmpty } from '@uc/utilities';
import {
	ClientFeatures,
	FeaturedClearing,
	ClientFeatureOptions,
	ClearingUniversityProfile,
	FeaturedUndergraduate,
	FeaturedPostgraduate,
} from '@uc/web/shared/data-models';
import { ClientValidatorService } from '@uc/web/core';
import { filter, map, Observable } from 'rxjs';
import { fetchClearingUniversity } from '../../data-access/+state/university.actions';
import { getStateClearingUniversity } from '../../data-access/+state/university.selectors';
import { ClientProfileStickyLeadBarDesktopComponent } from '@web/shared/feature/feature-sticky-lead-bar';
import { AsyncPipe } from '@angular/common';
import { Product } from '@uc/shared/data-models';
import { CLEARING_ENABLED } from '@uc/web/config';

@Component({
	selector: 'uc-cta-desktop-footer-container',
	templateUrl: './cta-desktop-footer-container.component.html',
	imports: [AsyncPipe, ClientProfileStickyLeadBarDesktopComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaDesktopFooterContainerComponent implements OnInit {
	isFeatured = input.required<FeaturedUndergraduate | FeaturedPostgraduate>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	uniSlug = input.required<string>();
	paidFeatures = input.required<ClientFeatureOptions[]>();
	externalUrl = input.required<string>();
	source = input.required<string>();
	externalEventsUrl = input.required<string>();
	externalProspectusUrl = input.required<string>();
	product = input.required<Product | null>();
	ugSearchOrderPosition = input.required<number | null>();
	cleSearchOrderPosition = input.required<number | null>();
	privacyPolicyUrl = input<string>('');

	// Only used when clearing is enabled.
	clearingEnabled = CLEARING_ENABLED;
	clearingUniversity$!: Observable<ClearingUniversityProfile | undefined>;
	isFeaturedClearing!: FeaturedClearing;
	isClearing = this._clearingSrv.isClearing();
	readonly clearingPaidFeatures = [
		ClientFeatures.Clearing,
		ClientFeatures.Calls,
		ClientFeatures.RegisterInterest,
		ClientFeatures.ClearingVisitWebsite,
	];

	constructor(
		private _store: Store,
		private _cvSrv: ClientValidatorService,
		private _clearingSrv: ClearingService,
	) {}

	ngOnInit(): void {
		// Only called when clearing is enabled.
		if (this.clearingEnabled) {
			this._store.dispatch(
				fetchClearingUniversity({
					uniSlug: this.uniSlug(),
				}),
			);

			this.clearingUniversity$ = this._store.pipe(
				select(getStateClearingUniversity),
				filter((university) => !isStoreEmpty(university)),
				map((university) => {
					if (!university) return;

					this.isFeaturedClearing = this._cvSrv.checkFeature(
						university.paid_features,
						this.clearingPaidFeatures,
					);
					return university;
				}),
			);
		}
	}
}
